//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpContentSection',
  components: {
    DpIcon,
  },
  props: {
    title: { type: String, default: '' },
    icon: { type: String, default: '' },
    noPadding: { type: Boolean, default: false },
    noMargins: { type: Boolean, default: false },
  },
};
